<template>
  <r-toggle-card
    title="Информация"
    :is-open="config.enabled"
    @toggle="toggleHandler"
  >
    <div class="c-popup">
      <ul class="c-popup__list" v-if="config.fields.length">
        <li class="c-popup__item" v-for="field in config.fields" :key="field">
          <div class="c-popup__info">
            <div :class="`c-popup__icon ${getType(field)}`" />
            <r-text>
              {{ field }}
            </r-text>
          </div>
          <el-button
            class="r-button icon-button"
            circle
            @click="removeField(field)"
          >
            <r-icon name="close" :size="12" />
          </el-button>
        </li>
      </ul>
      <el-select
        class="r-select dark"
        size="mini"
        v-model="config.fields"
        multiple
        collapse-tags
        @change="updateLayer"
      >
        <el-option
          v-for="field in fields"
          :key="field.title"
          :value="field.title"
          :label="field.title"
        >
          <span>{{ field.title }}</span>
        </el-option>
      </el-select>
    </div>
  </r-toggle-card>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    config() {
      return this.$store.state.calculations.stylesConfigs[this.id].popup;
    },
    fields() {
      return this.$store.state.calculations.objectFields[this.id] || [];
    }
  },
  methods: {
    getType(field) {
      const config = this.fields.find(f => f.title === field);

      return config.type;
    },
    toggleHandler(value) {
      this.config.enabled = value;
    },
    removeField(field) {
      this.$set(
        this.config,
        "fields",
        this.config.fields.filter(f => f !== field)
      );
    },
    updateLayer() {
      const fields = ["id", "geom", ...this.config.fields];

      this.$store.commit("SET_REQUESTED_FIELDS", { id: this.id, fields });

      this.$cControllers.layers.handlers[this.id]();
    }
  }
};
</script>

<style lang="scss">
.c-popup {
  .r-select {
    width: 100%;
  }

  &__list {
    margin-bottom: 16px;
  }

  &__item {
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 8px;
    display: flex;
    align-items: center;

    color: var(--field_primary_text) !important;
    border-color: var(--field_border) !important;
    background-color: var(--field_bg) !important;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .r-button.icon-button.is-circle {
      margin-left: auto;
      padding: 4px !important;
    }
  }

  &__info {
    display: flex;
    align-items: center;
  }

  &__icon {
    height: 16px;
    margin-right: 10px;
    width: 16px;
    background-size: 75%;
    background-position: 50%;
    opacity: 0.8;
    background-repeat: no-repeat;
    border-radius: 4px;

    &.string {
      background-image: url("../../../../assets/images/tree-attributes/types/string.svg");
      background-color: var(--string);
    }
    &.number {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--number);
    }
    &.numeric {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.integer {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.decimal {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.boolean {
      background-image: url("../../../../assets/images/tree-attributes/types/boolean.svg");
      background-color: var(--boolean);
    }
    &.date {
      background-image: url("../../../../assets/images/tree-attributes/types/datetime.svg");
      background-color: var(--date);
    }
    &.time {
      background-image: url("../../../../assets/images/tree-attributes/types/interval.svg");
      background-color: var(--time);
    }
  }
}
</style>
